import LazyLoad from "react-lazyload"
import styled from "styled-components"
import { useT } from "react-polyglot-hooks"
import * as PropTypes from "prop-types"
import { sendEvent } from "scripts/GoogleAnalytics"
import { emptyCarsFilter } from "redux/actions"
import { useDispatch } from "react-redux"
import Typography from "../styled/Typography"
import { TitleWrapper } from "../styled/Grid"
import ArrowButton from "../styled/Buttons/ArrowButton"
import ImagePlaceholder from "../ImagePlaceholder"

const Wrapper = styled.div`
  position: relative;
`

const Content = styled.div`
  position: absolute;
  padding: 25px;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const Img = styled.img`
  width: 100%;
  height: 250px;
  max-width: none;
  object-fit: cover;

  @media ${({ theme }) => theme.breakpoints.xl} {
    height: 300px;
  }
`

export default function OtherBrands({ page }) {
  const t = useT()
  const dispatch = useDispatch()
  const backgroundUrl = `${process.env.NEXT_PUBLIC_CLOUDINARY}w_auto,f_auto,q_auto/static/brand`

  const handleClick = () => {
    dispatch(emptyCarsFilter())
    sendEvent("Click CTA search car", { event_category: page, event_label: "Search car footer" })
  }

  return (
    <Wrapper>
      <LazyLoad height={250} placeholder={<ImagePlaceholder height={250} responsiveHeight={{ xl: 300 }} />}>
        <picture>
          <source
            srcSet={`${backgroundUrl}/other-375px,
                ${backgroundUrl}/other-375px_2x 2x,
                ${backgroundUrl}/other-375px_3x 3x`}
            media="(max-width: 375px)"
          />
          <source
            srcSet={`${backgroundUrl}/other-768px,
                ${backgroundUrl}/other-768px_2x 2x,
                ${backgroundUrl}/other-768px_3x 3x`}
            media="(max-width: 768px)"
          />
          <source
            srcSet={`${backgroundUrl}/other-1024px,
                ${backgroundUrl}/other-1024px_2x 2x,
                ${backgroundUrl}/other-1024px_3x 3x`}
            media="(max-width: 1024px)"
          />
          <source
            srcSet={`${backgroundUrl}/other-1440px,
                ${backgroundUrl}/other-1440px_2x 2x,
                ${backgroundUrl}/other-1440px_3x 3x`}
          />
          <Img alt="other cars" src={`${backgroundUrl}/other-768px`} />
        </picture>
      </LazyLoad>
      <Content>
        <TitleWrapper>
          <Typography variant="title2" weight="medium" color="white" center space el="h3">
            {t("common.other_brands")}
          </Typography>
        </TitleWrapper>
        <ArrowButton size="lg" style={{ border: "none" }} border onClick={handleClick} page="stock">
          {t("common.view_all_offers")}
        </ArrowButton>
      </Content>
    </Wrapper>
  )
}

OtherBrands.propTypes = {
  page: PropTypes.string.isRequired
}
